import { FC } from 'react';
import { Box, VStack, HStack, Text, Textarea, Switch } from '@chakra-ui/react';
import { useDefaultStyles } from '../../../../hooks/useDefaultStyles';
import { PrimaryButton } from '../../../../lib/components/PrimaryButton';

interface ModalStep3Props {
  comment: string,
  setComment: (v: string) => void,
  participate: boolean,
  onSetParticipate: () => void,
  onCompleteSurvey: () => void,
}

export const ModalStep3: FC<ModalStep3Props> = ({
  comment,
  setComment,
  participate,
  onSetParticipate,
  onCompleteSurvey,
}) => {
  const { colors } = useDefaultStyles();

  return (
    <VStack align="left">
      <Box p="8px 16px" backgroundColor="#041223">
        <Text fontSize="20px" fontWeight="bold" color="#89B2F9">
          Como podemos tornar a Aristo ainda melhor para você?
        </Text>
      </Box>
      <VStack p="16px 24px" spacing="16px">
        <Textarea
          variant="filled"
          size="lg"
          fontSize="md"
          minH={200}
          value={comment}
          onChange={e => setComment(e.target.value)}
        />

        <HStack>
          <Switch
            checked={participate}
            onChange={_ => onSetParticipate()}
            size="lg"
          />
          <Text fontSize="14px">
            Gostaria de participar de testes e nos ajudar a melhorar a Aristo?
          </Text>
        </HStack>

        <PrimaryButton
          onClick={onCompleteSurvey}
          disabled={!comment.length}
          fontSize="14px"
          isFullWidth
          backgroundColor={colors.customColors.lightBlue}
        >
          Enviar
        </PrimaryButton>
      </VStack>
    </VStack>
  );
};
